import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CheckboxModel } from 'src/app/model/checkboxData.model';
import { Tooltip } from 'src/app/model/tooltip';
import { UtilService } from 'src/app/shared';
@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit, OnDestroy {

  @Input() label: string;
  @Input() question: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() editMode: boolean;
  private isChecked: boolean;
  public checkboxData: CheckboxModel[];
  private numberOfCheckbox: number;
  checkboxCtlNameToApi: string;
  tooltipObj: Tooltip;
  subscription: Subscription;
  @Output() selectedValChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: UntypedFormBuilder, private utilService: UtilService) {

  }

  ngOnInit(): void {
    this.createCheckboxListBasedNumberOfCheckbox();
    this.checkboxCtlNameToApi = this.question.id + 'checkbox';
    let selectedOption = this.question.responseValueByUser ? this.question.responseValueByUser : "";
    this.setFormValueForCheckBox(this.question, selectedOption);

    this.initializeInfoText();
  }

  initializeInfoText() {
    this.tooltipObj = new Tooltip(this.question.helpText, '', false);
  }

  createCheckboxListBasedNumberOfCheckbox() {
    if (this.question.responseValue && this.question.responseValue.length > 0) {
      this.checkboxData = [];
      this.question.responseValue.forEach((element, index) => {
        let tempId: string = element + '-' + this.question.id;
        let temp: CheckboxModel = { id: tempId, value: element, selected: false };
        this.checkboxData.push(temp);
      });
    }
  }

  setFormValueForCheckBox(question: LifeStyleQuestion, option: string) {

    let formArrayForCheckBox = this.checkboxData.map(item => {
      return this.fb.group({
        id: item.id,
        value: item.value,
        selected: item.selected,
      });
    });

    this.parent.addControl(question.id, this.fb.array(formArrayForCheckBox));
    this.parent.addControl(this.checkboxCtlNameToApi, this.fb.control(null, null));
    if (option) {
      let obj: any = this.parent.controls[this.question.id];
      if (obj && obj.controls) {
        obj.controls.forEach(item => {
          if ((item) && (item.value) && (option === item.value.value)) {
            this.onSelectOfCheckbox(null, item, true);
          }
        });

      }
    }
    else {
      this.setValueForCheckBoxToPrepareBackend();
    }
  }

  setValueForCheckBoxToPrepareBackend() {
    let obj = this.parent.controls[this.question.id];
    let selectedOptions: string[] = [];
    if (obj && obj.value) {
      obj.value.forEach(element => {
        if (element.selected === true) {
          selectedOptions.push(element.value);
        }
      });
    }
    let value = (selectedOptions.length > 0) ? selectedOptions[0] : null;
    this.parent.controls[this.checkboxCtlNameToApi].setValue(value);
  }

  onSelectOfCheckbox(event: Event, data: UntypedFormGroup, onPageLoad?: boolean) {
    if (this.editMode && !onPageLoad) { // if (this.editMode && !onPageLoad) {
      if (!this.subscription) {
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
          if (res) {
            this.editMode = false;
            if (data && res && res.value) {
              if (data.controls && data.controls.id &&
                (data.controls.id.value === res.value.id)) {
                data.controls.selected.setValue(res.value.selected);
                this.onSelectOfCheckbox(event, data);
              }
            }
          }
        });
      }
      const payload = {
        value: data.value,
        screen: 'checkbox-standard'
      };
      this.editModelHandler.emit(payload);
    } else {
      let flag = data.value.selected;
      flag = !flag;
      data.controls.selected.setValue(flag);
      this.question.responseValueByUser = data.value.value;
      this.setValueForCheckBoxToPrepareBackend();
      setTimeout(() => {
        if (flag) {
          this.selectedValChange.emit(data.value.value);
        } else {
          this.selectedValChange.emit(null);
        }
      }, 100);
      //console.log('Checkbox Formcontrol->', this.parent.controls[this.checkboxCtlNameToApi]);
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }

  displayMobileTooltipReceiver(question_id){
    this.onDisplayMobileTooltipEmitter.emit();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
